<template>
  <div>
    <div id="main" style="width: 100%;"></div>
  </div>
</template>

<script>
import "../../node_modules/echarts/map/js/world";
export default {
  name: "echarts",
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      var geoCoordMap = {
        center: [111.457121, 23.844305],
        a: [140.009725, 53.329753],
        b: [14.319393, 65.110086],
        c: [7.081207,52.490048],
        d: [-63.096432, -16.957193],
        e: [-78.991696,36.582859],
        f: [-104.89509,19.721315],
        g: [9.904042,-0.321012],
        h: [38.16229,-6.824581],
      };

      var GXData = [
        [{ name: "center" }, { name: "a", value: 5 }],
        [{ name: "center" }, { name: "b", value: 5 }],
        [{ name: "center" }, { name: "c", value: 5 }],
        [{ name: "center" }, { name: "d", value: 5 }],
        [{ name: "center" }, { name: "e", value: 5 }],
        [{ name: "center" }, { name: "f", value: 5 }],
        [{ name: "center" }, { name: "g", value: 5 }],
        [{ name: "center" }, { name: "h", value: 5 }],
      ];

      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var dataItem = data[i];
          var fromCoord = geoCoordMap[dataItem[0].name];
          var toCoord = geoCoordMap[dataItem[1].name];
          if (fromCoord && toCoord) {
            res.push({
              fromName: dataItem[0].name,
              toName: dataItem[1].name,
              coords: [fromCoord, toCoord]
            });
          }
        }
        return res;
      };
      var series = [];
      [["", GXData]].forEach(function(item, i) {
        series.push(
          // 飞行路线
          {
            name: item[0] + " Top10",
            type: "lines",
            zlevel: 1,
            effect: {
              show: true,
              period: 6,
              trailLength: 0.7,
              color: "#fff",
              symbolSize: 3
            },
            lineStyle: {
              normal: {
                color: "#fff",
                width: 0,
                curveness: -0.12
              }
            },
            data: convertData(item[1])
          },
          {
            name: item[0] + " Top3",
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              brushType: "stroke"
            },
            symbolSize: 12,
            itemStyle: {
              normal: {
                color: "#fff"
              }
            },
            data: item[1].map(function(dataItem) {
              return {
                name: dataItem[1].name,
                value: geoCoordMap[dataItem[0].name].concat([dataItem[0].value])
              };
            })
          },
          //   飞行的小圆点
          {
            name: item[0] + " Top10",
            type: "lines",
            zlevel: 2,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbolSize: 8
            },
            lineStyle: {
              normal: {
                color: "#fff",
                width: 1,
                opacity: 0.4,
                curveness: -0.12
              }
            },
            data: convertData(item[1])
          },
          //飞行起点
          {
            name: item[0] + " Top3",
            type: "scatter",
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              brushType: "stroke"
            },
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#fff'
              }
            },
            data: item[1].map(function(dataItem) {
              return {
                name: dataItem[1].name,
                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
              };
            })
          }
        );
      });


      let chartsbox_1 = this.$echarts.init(document.getElementById("main"));

      chartsbox_1.setOption({

        geo: {
          map: "world",
          zoom: 1.32,
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#3170c8",
              borderWidth: "0.9",
              borderColor: "#3170c8",
            },
            emphasis: {
              areaColor: "#3170c8"
            }
          }
        },
        series: series
      });
    }
  }
};
</script>

<style>
#main{
    height: 800px;
}
@media screen and (max-width: 992px){
    #main{
    height: 320px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts.vue